import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AfterViewInit, ChangeDetectionStrategy, Component, computed, DestroyRef, effect, input, signal, viewChild} from "@angular/core";
import {GruppeModell, Gruppetype} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatSelect, MatSelectModule} from "@angular/material/select";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldControl} from "@angular/material/form-field";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {harSammeId} from "felles-ng2/modell/modellHjelpere";
import {Subject} from "rxjs";
import {TranslateModule} from "@ngx-translate/core";
import {MatFormFieldControlProxy} from "web-ng2/delt/material/MatFormFieldControlProxy";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {GruppeLogoKomponent} from "web-ng2/moduler/gruppe/komponenter/gruppe-logo/gruppe-logo";
import {alleGrupperMedType} from "felles-ng2/modell/gruppeModellHjelpere";
import {erListe, første} from "felles-ng2/støttefunksjoner/lister";

const debug = initDebugger('VelgMedlemKomponent');


/** Viser dropdown med grupper.
 * <pre>
 * Fungerer med Ng reactive form via ([(skjemakontroll)]="...").
 * Fungerer med <mat-form-field> fra Material.
 *
 * MERK at vi ikke implementerer ControlValueAccessor fra angular.forms, så komponenten vil ikke fungere med
 * [(ngModel)]="..." eller [formControl]="...".
 * </pre>
 */
@Component({
    selector: 'velg-gruppe',
    templateUrl: 'velg-gruppe.html',
    styleUrl: 'velg-gruppe.scss',
    providers: [{
        provide: MatFormFieldControl,
        useFactory: (komponent: VelgGruppeKomponent) => new MatFormFieldControlProxy(() => komponent.nedtrekksmeny(), komponent.stateChanges),
        deps: [VelgGruppeKomponent]
    }],
    imports: [
        MatSelectModule,
        ReactiveFormsModule,
        TranslateModule,
        GruppeLogoKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VelgGruppeKomponent implements AfterViewInit {

    private nedtrekksmeny = viewChild.required<MatSelect>('gruppevelger');

    skjemakontroll = input.required<FormControl<GruppeModell | GruppeModell[] | null>>();
    grupper = input.required<GruppeModell[]>();
    placeholder = input('');
    visLogo = input(true);
    multiple = input(false);

    ordindaereGrupper = computed(() => alleGrupperMedType(this.grupper(), Gruppetype.ordinær));
    malGrupper = computed(() => alleGrupperMedType(this.grupper(), Gruppetype.mal))
    antallValgt = signal(0);
    foersteValgteGruppe = signal<GruppeModell | null>(null);

    erValgt = harSammeId;

    private readonly stateChanges = new Subject<void>();

    constructor(private destroyRef: DestroyRef) {
        effect(() => {
            this.skjemakontroll().valueChanges.subscribe(valgteGrupper => {
                if (erListe(valgteGrupper)){
                    this.antallValgt.set(valgteGrupper.length);
                    this.foersteValgteGruppe.set(første(valgteGrupper));
                }else {
                    this.antallValgt.set(erNil(valgteGrupper) ?0:1);
                    this.foersteValgteGruppe.set(valgteGrupper);
                }
            })
        });
    }

    giFokus() {
        this.nedtrekksmeny().focus();
    }

    ngAfterViewInit(): void {
        this.nedtrekksmeny().stateChanges
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.stateChanges.next())
    }

    //hjelpemetoder
}
